import { createFileRoute } from "@tanstack/react-router";
import UhcMarketplaceInsurance, {
  config,
} from "@/pages/UhcMarketplaceInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/uhc-marketplace-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "UnitedHealthcare Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "UnitedHealthcare Marketplace insurance for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content:
            "UnitedHealthcare Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "UnitedHealthcare Marketplace insurance for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/uhc-marketplace-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/uhc-marketplace-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <UhcMarketplaceInsurance />;
}
